import { axiosDefault } from '@/core/utils';
import { AuthentificationRequest } from '@/core/interfaces';
import { UserStatusMapper, LeaderboardMapper, SeasonMapper } from '@/core/mappers';

const authentificate = async ({
	referral,
	isLaunching,
}: AuthentificationRequest) => {
	let url = `/tg/user/extra`;

	// Construct query parameters efficiently
	const params: Record<string, any> = {};
	if (referral) params.referral = referral;
	if (isLaunching === 1) params.launch = isLaunching;

	// Append query parameters to the URL
	const queryString = new URLSearchParams(params).toString();
	if (queryString) url += `?${queryString}`;

	const response = await axiosDefault.get(url);
	const isNewUser: boolean = response.headers['tg-is-new-user'];
	const isAirdropUser: boolean = response.headers['is-airdrop-user'];

	return {
		userInfo: UserStatusMapper(response.data),
		isNewUser: !!isNewUser, // Ensure it defaults to false if isNewUser is undefined
		isAirdropUser: !!isAirdropUser,
	};
};

const setEmail = async (email: string) => {
	let url = `/tg/user/vottunworld/signup?username=${email}`;
	const response = await axiosDefault.put(url);

	return {
		currentCoins: response.data.currentCoins,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
	};
};


const leaderboard = async (seasonID: Number) => {
	if (seasonID !==-2){
		let url = `/tg/leaderboard/`+seasonID;
		const response = await axiosDefault.get(url);
		return {
			userInfo: LeaderboardMapper(response.data),
		};
	}else{
		let url = `/tg/master-leaderboard`;
		const response = await axiosDefault.get(url);
		return {
			userInfo: LeaderboardMapper(response.data),
		};
	}
};

const fetchSeasons = async()=>{
	let url = `/tg/get-season`
	const response = await axiosDefault.get(url);
	return {
		seasons: SeasonMapper(response.data),
	};
};

export const AuthService = {
	authentificate,
	setEmail,
	leaderboard,
	fetchSeasons,
};
